/**
 * Shorthand for .hasOwnProperty
 * @param {object} object or class
 * @param  {string} property
 * @return {boolean} true\false
 */

export const hasProp = (obj, prop) => {
    return Object.prototype.hasOwnProperty.call(obj, prop);
};
